function extractIdData(reportId) {
  if (reportId.length >= 12) {
    const extractedIdData = {
      idSystem: reportId.slice(0, 3), // length 3
      idState: reportId.slice(3, 5), // 2
      idLocation: reportId.slice(5, 7), // 2
      idPatient: reportId.slice(7, 11), // 4
      idCkDigit: reportId.slice(11, 12), // length 1
    };
    return extractedIdData;
  }
  return {
    idSystem: '000', // length 3
    idState: '00', // 2
    idLocation: '00', // 2
    idPatient: '0000', // 4
    idCkDigit: '0', // length 1
  };
}
export default extractIdData;



// WEBPACK FOOTER //
// ./src/functions/extractIdData.js